// Generic parent class that implements common
// functionality for roof types
// An implementation of a roof has inputs which 
// defines the fields of the roof, see vroof etc. 
// each input field can either have a fixed input 
// suck as length, but also different display 
// alternatives such as height which can also be
// defined through angle. Such an alternative
// is specified in an alternatives object of a
// specified form. Example input
//{
//        name: "height",
//        title: text.height,
//        // [optional]
//        alternatives:{
//          // names of the different alernatives for this field,
//          // the name should be identical to the Text.js entry
//          names: ["angle"], 
//          // Function converting from the original field to the 
//          // user specified field i.e. from height to angle etc.
//          // @param values holds the values of the current roof
//          convertTo: function(propertyName, height, values){
//            if (propertyName == "height"){
//              return height;
//            }
//            return angle(height,values["width"]);
//          },
//          // Converts from the property propertyName to the original 
//          // field value, in this case height
//          convertFrom: function(propertyName, propertyValue, values){
//            if (propertyName == "height"){
//              return propertyValue;
//            }
//            return angleToHeight(values["width"], propertyValue);
//          },
//        },
//      },

export default class Roof {
  constructor(r,p) {
    this.props = r
    this.plate = p
    this.inputs = [];
  }

  // Turns it into a geometric description that
  // can be run straight through the optimization
  // library
  topatches() {
    throw "unimplemented"
  }

  patchtransforms() {
    throw "unimplemented"
  }

  pipes() {
	  return []
	}

  // length of mone (takas) of the roof
  mone() {
    return 0.0;
  }

  // length of vindski (vindskiva) of the roof
  vindski(){
    return 0.0;
  }

  // Validate the roofs input given an input object, assumes reasonable 
  // input, i.e. > 0, a number etc. Output is an 
  // object with a string for each input causing
  // an error, undefined if none
  validateInput(inputs){
    return undefined;
  }

  fromarr(a) {
    if(1 == undefined || a.length == undefined)
      a = arguments
    let p = [];
    for(let i = 0; i < a.length; i+=2) {
      p.push({
        X: a[i],
        Y: a[i+1],
      })
    }
    return p
  }

  fromrect(length, height) {
    return this.fromarr([
      0,0,
      length,0,
      length, height,
      0, height,
    ])
  }

  // Equilateral triangle
  fromtriangle(width, height) {
    return this.fromarr([
      0,0,
      width, 0,
      width/2.0,height,
    ])
  }

  // Return angle in radians from height in meters
  static angle(height, width){
    return Math.atan2(height,width/2);
  }

  // Angle in radians to height in meters
  static angleToHeight(width, angle){
    return Math.tan(angle)*width/2;
  }

  static radianToDegree(){
    return 180.0/Math.PI;
  }

  static degreeToRadian(){
    return Math.PI/180.0;
  }

}



// WEBPACK FOOTER //
// ./roofs/roof.js